import { PageContainer, PageContent } from "../components/PageContainer";
import { TitleBar } from "../components/TitleBar";
import {
  HomePublishSection,
  SlidesPublishSection,
} from "../components/Publishing";
import { useAtomValue } from "jotai";
import { userAtom } from "../atoms";
import { SectionCard } from "../components/HomeLayouts";

const Home = (): JSX.Element => {
  const user = useAtomValue(userAtom);

  return (
    <PageContainer>
      <PageContent className="flex flex-col gap-4">
        <SectionCard>
          <TitleBar
            title={user?.username ? `Welcome ${user?.username}!` : "Welcome!"}
          />
          <div className="text-sm space-y-4">
            <p>
              NextSense staff can use this Content Management System to add,
              edit and delete content on the School Foyer and Digital Signage
              screens throughout the Centre of Excellence.
            </p>
            <p>
              Content can be found in the three sections in the left-hand
              navigation panel. Users can be organised in the 'Manage Users'
              section (visible to Administrator accounts only).
            </p>
            <p>
              When content has been updated in a section, please use the 'Push
              Changes' button to push the new content to the screens. Any
              updates will be shown on the screens on startup the following day.
            </p>
          </div>
        </SectionCard>
        <SectionCard>
          <div className="font-bold">School Photos & Student Works</div>
          <HomePublishSection />
        </SectionCard>
        <SectionCard>
          <div className="font-bold">Digital Signage Slides</div>
          <SlidesPublishSection />
        </SectionCard>
      </PageContent>
    </PageContainer>
  );
};

export default Home;
